export const getters = {
  CANDIDATES_MODE: state => state.candidatesMode,
}
